<template>
<teleport to="body">
  <div class="progress-content">
    <div class="progress-bar" :style="currentStyleObj"></div>
  </div>
</teleport>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch } from "vue";
import useSettingStore from "@/store/setting";

const settingStore = useSettingStore()

const currentStyleObj = ref({
  width : '0',
  opacity : 1
})
const timer = ref()
const beforeJump = () => {
  currentStyleObj.value.width = '20%'
  currentStyleObj.value.opacity = 1
  timer.value = setTimeout(() => {
    currentStyleObj.value.width = '30%'
  },1000)
}

const afterJump = () => {
  clearTimeout(timer.value)
  currentStyleObj.value.width = '100%'
  setTimeout(() => {
    currentStyleObj.value.opacity = 0
  },400)
  setTimeout(() => {
    currentStyleObj.value.width = '0'
  },1000)
}

watch(() => settingStore.isJump, (newVal) => {
  if (newVal === 'before') {
    beforeJump()
  } else {
    afterJump()
  }
})

</script>

<style lang="scss" scoped>
.progress-content {
  position: absolute;
  width: 100%;
  height: 3px;
  top: 0;
  z-index: 20;
  .progress-bar {
    height: 4px;
    background-color: #624dff;
    transition: all 0.4s ease;
    //transition: opacity 0.4s ease;
  }
}
</style>